import * as React from 'react';

import { Input } from '@travelnest/merlin.input';
import theme from '@travelnest/merlin.theme';
import { Link } from 'react-router-dom';
import { focusComponent } from '../../helpers/components';
import { BlueButton, ErrorMessage, HelpFeaturedContainer } from './components';
import { friendlyMessage } from './helpers';

export interface ILoginPasswordProps {
	initialPassword?: string;
	loading: boolean;
	focusInput?: boolean;
	error?: Error | null;
	onChange: (password: string) => void;
	onSubmit: () => void;
	onResetPassword: () => void;
}

export const LoginPassword: React.FC<ILoginPasswordProps> = ({
	initialPassword, onChange, onSubmit, onResetPassword, loading, focusInput, error
}) => {
	const [password, setPassword] = React.useState(initialPassword || '');
	const [showPassword, setShowPassword] = React.useState(false);

	const dynamicProps = focusInput ? { ref: focusComponent } : {};

	const { message, action } = error ? friendlyMessage(error.message) : { message: null, action: null };

	return <HelpFeaturedContainer>
		<h1>Log in to your Travelnest account</h1>
		<form onSubmit={(e) => {
			e.preventDefault();
			onSubmit();
		}}>
			<div>
				<h3 style={{ marginBottom: theme.layout.spacing.smallest }}>Password</h3>
				<div style={{ display: 'flex' }}>
					<Input
						id="login-password-input"
						type={showPassword ? 'input' : 'password'} value={password} {...dynamicProps} onChange={(e) => {
							const nextPassword = e.target.value;
							setPassword(nextPassword);
							onChange(nextPassword);
						}} />
					<a style={{ margin: `auto 0 auto ${theme.layout.spacing.standard}` }} href="#" onClick={(e) => {
						e.preventDefault();
						setShowPassword(!showPassword);
					}}>{showPassword ? 'Hide' : 'Show'}</a>
				</div>
			</div>
			{error && <ErrorMessage>
				{message}
				{action === 'reset' ? <><br /><a id="security-password-reset" href="#" onClick={() => onResetPassword()}>Reset your password.</a></> : null}
			</ErrorMessage>}
			<div style={{ marginTop: theme.layout.spacing.standard }}>
				<BlueButton disabled={!password} loading={loading}>Login</BlueButton>
			</div>
		</form>
		<div style={{ marginTop: theme.layout.spacing.standard }}>
			<Link id="forgot-password-link" to={`/reset`}>Forgotten your password?</Link>
		</div>

	</HelpFeaturedContainer>;
};
